import type { RicosDocument } from '../generated/ricos_document';
import rootSchema from '../generated/ricos_document.jtd.json';
import { validate as v } from '../json-typedef-js-fork/validate';
import type { EditorPluginName } from '../plugin-names';
import { pluginsToFeatures } from '../plugin-to-feature';

export type ValidationError = {
  /**
   * instancePath is the path to a part of the instance, or "input", that was
   * rejected.
   */
  instancePath: string[];
  /**
   * schemaPath is the path to the part of the schema that rejected the input.
   */
  schemaPath: string[];
  /**
   * description of the error
   */
  message: string;
};

export function validateRicosDocument(
  content: any,
  options?: {
    plugins?: EditorPluginName[];
  }
): { type: 'ok'; content: RicosDocument } | { type: 'error'; errors: ValidationError[] } {
  const errors = v(rootSchema as any, content, {
    features: options?.plugins ? pluginsToFeatures(options.plugins) : undefined,
  });
  if (!errors.length) {
    return { type: 'ok' as const, content: content as RicosDocument };
  }
  return { type: 'error' as const, errors: errors ?? [] };
}
